// extracted by mini-css-extract-plugin
export default {"btop":"_8a38814df5 _96c5fdc6a2 _16206dfd29","icon":"d5918c2505 _9bc7e4f1e6","btoppink":"d60f5f1b07 c0918a0c19"};